import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/auth.service';
import { selectIsAuth } from 'src/app/redirect/reducers';
import * as headerActions from '../header.actions';
import { UserService } from 'src/app/user.service';
import * as fromUserConfirmed from '../../userconfirmed.reducer';
import { agreeConfirmModal, closeConfirmModal, loadConfirmModal } from '../header.actions';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {

  isAuth: boolean;
  isAuth$$: Subscription;
  isConfirmed$$: Subscription;
  @ViewChild('confirmsignin') confirmsignin: ModalDirective;
  @ViewChild('treasureModal') treasuremodal: ModalDirective;

  constructor(
    private store: Store,
    private router: Router,
    private authService: AuthService) { }

  ngOnInit(): void {
    this.checkAuth();
  }

  ngAfterViewInit() {
    this.checkConfirm();
  }

  checkConfirm() {
    this.isConfirmed$$ =
    this.store.select(fromUserConfirmed.selectUserConfirmed)
    .subscribe(confirm => {
      if (confirm.confirm === false && confirm.prompt === 0) {
        this.confirmsignin.show();
        this.store.dispatch(loadConfirmModal());
      }
    });
  }

  onCloseConfirmModal() {
    this.store.dispatch(closeConfirmModal());
    this.router.navigate(['/homepage']);
  }

  onConfirmSignin() {
    this.store.select(fromUserConfirmed.selectConfirmInfo)
    .pipe(
      take(1)
    ).subscribe(info => {
      this.store.dispatch(agreeConfirmModal({data: info}));
      this.confirmsignin.hide();
    });
  }

  checkAuth() {
    this.isAuth$$ =
    this.store.select(selectIsAuth)
    .subscribe(auth => {
      this.isAuth = auth;
    });
  }

  onSignin() {
    this.authService.signin();
  }

  onSignOut() {
    // this.userService.logout().subscribe();
    this.store.dispatch(headerActions.signOut());
    this.authService.signout();
  }

  onTreasure() {
    if (this.isAuth) {
      this.treasuremodal.show();
      this.router.navigate([], {queryParams: {showTreasure: null}});
    } else {
      this.router.navigate([], {queryParams: {showTreasure: true}});
      this.onSignin();
    }
  }

  ngOnDestroy() {
    this.isAuth$$.unsubscribe();
    this.isConfirmed$$.unsubscribe();
  }


}
